import React, { useEffect, useState } from 'react'
import { useScoreStore } from 'store/ScoreStore'
import RoomInfo from 'types/RoomInfo'
import { DraggableList } from '../components/DraggableList/DraggableList'
import { useNavigate } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'
import { indexOf } from 'lodash'
import Rooms from '../data/rooms'

export default function ScoringPage () {
  const navigate = useNavigate()
  const [backgroundClass, setBackgroundClass] = useState('bg-transparent')
  const roomId = useScoreStore((state) => state.roomScoreId)
  const hazardsFound = useScoreStore((state) => state.hazardsFound)

  const [showResults, setShowResults] = useState(false)
  const [showList, setShowList] = useState(true)
  const [score, setScore] = useState(useScoreStore.getState().score)

  // Load room details and info from a DB here... for now...
  const roomDetails: () => RoomInfo | null = () => {
    if (!roomId) return null
    if (Rooms[roomId]) return Rooms[roomId]

    return null
  }

  const getHazardList = () => {
    const room = roomDetails()
    if (!room) return []
    return room.hazards
  }

  const missedHazardsCount = () => {
    return getHazardList().filter((h) => h.value > 0).length - useScoreStore.getState().hazardsFound.length
  }

  let hazardsFoundSorted: string[] = []
  const dragCallback = (newOrder: number[]) => {
    const hazards: string[] = []
    newOrder.forEach((no) => {
      hazards.push(hazardsFound[no])
    })
    hazardsFoundSorted = hazards
  }

  const calculateScore = () => {
    const room = roomDetails()
    if (!room) return 0

    // Check if the order given is in the correct priority
    // First make sure the array is in the correct order
    room.hazards.sort((a, b) => {
      return a.priority - b.priority
    })
    // Then copy and remove the elements that were missed
    const roomHazards = room.hazards.filter((h) => {
      return indexOf(hazardsFound, h.id) >= 0
    })

    // Now compare order with our selection
    let correctOrder = 0
    hazardsFoundSorted.forEach((h, i) => {
      if (roomHazards[i].id === h) correctOrder++
    })

    if (room) {
      let score = room.orderBonus * correctOrder

      // Penalty for missed hazards
      score -= (missedHazardsCount() * room.missPenalty)

      // Add Found hazards
      hazardsFound.forEach((h) => {
        const hazard = room.hazards.find(s => s.id === h)
        if (hazard) score += hazard.value
      })

      setScore(score)
      return score
    }
    setScore(0)
    return 0
  }

  useEffect(() => {
    setBackgroundClass('bg-primary-lightBlue')
    if (!roomId) navigate('/')
  }, [])

  const handleSubmitClick = () => {
    if (!showResults) {
      setShowResults(true)
      calculateScore()
    }
  }

  const handleHomeClick = () => {
    useScoreStore.getState().setRoomScoreId('')
    navigate('/')
  }

  return (
    <div className="App">
      <div className={'w-full h-body relative bg-transparent'}>
        <div className={'w-full h-body relative animation-fadeIn ' + backgroundClass}>

          <div className={'w-full h-body absolute grid content-center'}>
            <CSSTransition in={!showResults}
                           classNames={'animation-pop'}
                           timeout={300}
                           unmountOnExit
                           onEnter={() => setShowList(true)}
                           onExited={() => setShowList(false)}>
              <div className={'mx-auto max-w-[460px]'}>
                <p className='text-2xl font-bold text-primary-blue'>
                  Do you think you&apos;re done with the {useScoreStore.getState().roomScoreId}?<br /><br />
                  Try reordering the hazards below into priority
                </p>

                <div
                  className='mx-auto mt-[20px] text-center border-[12px] border-primary-blue rounded-[24px] relative'>
                  <div className='absolute -top-[50px] left-0 right-0 flex justify-center'>
                    <img src='/images/clip.svg' alt='' className='' />
                  </div>
                  <div className='bg-white p-[10px]'>
                    <DraggableList items={hazardsFound} dragCallback={dragCallback} />
                  </div>
                </div>

                <div className={'mt-[20px] text-center'}>
                  <button className={'btn--blue'} onClick={handleSubmitClick}>Submit</button>
                </div>
              </div>
            </CSSTransition>

            <CSSTransition in={!showList}
                           classNames={'animation-pop'}
                           timeout={300}
                           unmountOnExit>
              <div className={'mx-auto max-w-[460px]'}>
                <p className='text-2xl font-bold text-primary-blue'>
                  Congrats on completing the level
                </p>

                {missedHazardsCount() &&
                  <p className={'text-xl font-medium text-red-800 my-2'}>
                    You missed <b>{missedHazardsCount()}</b> hazards
                    losing <b>{missedHazardsCount() * (roomDetails()?.missPenalty ?? 1)}</b> points!
                  </p>
                }

                <div
                  className='mx-auto mt-[60px] text-center border-[12px] border-primary-blue rounded-[24px] relative'>
                  <div className='absolute -top-[50px] left-0 right-0 flex justify-center'>
                    <img src='/images/clip.svg' alt='' className='' />
                  </div>
                  <div className='bg-white px-[10px] py-[20px]'>
                    Your Score: {score}
                  </div>
                </div>

                <div className={'mt-[60px] text-center'}>
                  <button className={'btn--blue'} onClick={handleHomeClick}>Home</button>
                </div>
              </div>
            </CSSTransition>
          </div>

        </div>
      </div>
    </div>
  )
}
